export const EmissionSourceProcesses: string[] = [
  '000000',
  '000001',
  '000002',
  '000003',
  '000004',
  '000005',
  '000006',
  '000007',
  '000008',
  '000999',
  '010001',
  '010002',
  '010003',
  '010004',
  '010005',
  '010006',
  '010007',
  '010009',
  '010011',
  '010012',
  '010019',
  '010021',
  '010022',
  '010023',
  '010029',
  '010031',
  '010032',
  '010033',
  '010034',
  '010039',
  '020001',
  '020002',
  '030001',
  '030002',
  '030003',
  '050001',
  '050002',
  '060001',
  '060002',
  '070001',
  '070002',
  '070003',
  '070004',
  '070005',
  '070006',
  '070007',
  '070099',
  '080001',
  '080002',
  '080009',
  '080012',
  '080019',
  '080022',
  '080023',
  '080024',
  '080029',
  '080031',
  '080032',
  '080033',
  '080034',
  '080035',
  '080036',
  '080037',
  '080038',
  '080039',
  '080040',
  '080041',
  '080042',
  '080044',
  '080045',
  '080046',
  '080047',
  '080048',
  '080049',
  '080050',
  '080051',
  '080052',
  '080053',
  '080054',
  '080055',
  '080999',
  '090001',
  '090002',
  '090003',
  '090009',
  '100001',
  '110001',
  '110002',
  '110003',
  '110004',
  '110005',
  '110009',
  '110011',
  '110012',
  '110013',
  '110014',
  '110015',
  '110019',
  '110021',
  '110022',
  '110023',
  '110024',
  '110025',
  '110026',
  '110027',
  '110029',
  '110031',
  '110032',
  '110033',
  '110034',
  '110035',
  '110036',
  '110037',
  '110038',
  '110039',
  '110040',
  '110041',
  '110049',
  '120001',
  '130001',
  '130002',
  '130003',
  '130004',
  '130011',
  '130012',
  '130013',
  '130014',
  '130019',
  '130022',
  '130099',
  '130199',
  '140001',
  '140002',
  '140003',
  '140004',
  '140005',
  '140006',
  '140007',
  '140008',
  '140009',
  '140999',
  '150001',
  '150002',
  '150003',
  '150004',
  '150005',
  '150006',
  '150007',
  '150008',
  '150009',
  '150999',
  '160001',
  '160002',
  '160003',
  '160004',
  '160005',
  '160006',
  '160009',
  '160011',
  '160012',
  '160013',
  '160014',
  '160015',
  '160019',
  '160021',
  '160022',
  '170001',
  '170002',
  '170003',
  '170004',
  '170005',
  '170006',
  '170007',
  '170008',
  '170009',
  '170010',
  '170011',
  '170012',
  '170013',
  '170014',
  '170015',
  '170016',
  '170017',
  '170018',
  '170019',
  '170020',
  '170021',
  '170022',
  '170023',
  '170024',
  '170999',
  '180001',
  '180002',
  '180003',
  '180004',
  '180005',
  '180006',
  '180009',
  '180011',
  '180012',
  '180013',
  '180014',
  '180015',
  '180016',
  '180019',
  '180021',
  '180022',
  '180023',
  '180024',
  '180025',
  '180029',
  '180031',
  '180032',
  '180039',
  '180041',
  '180042',
  '180043',
  '180044',
  '180045',
  '180046',
  '180047',
  '180049',
  '180051',
  '180052',
  '180053',
  '180054',
  '180055',
  '180056',
  '180059',
  '180061',
  '180062',
  '180063',
  '180064',
  '180065',
  '180066',
  '180067',
  '180068',
  '180069',
  '180071',
  '180072',
  '180073',
  '180074',
  '180075',
  '180076',
  '180077',
  '180078',
  '180079',
  '180080',
  '180081',
  '180082',
  '180083',
  '180084',
  '180085',
  '180099',
  '180101',
  '180102',
  '180109',
  '180111',
  '180112',
  '180113',
  '180114',
  '180115',
  '180116',
  '180117',
  '180118',
  '180119',
  '180120',
  '180121',
  '180122',
  '180123',
  '180124',
  '180125',
  '180126',
  '180129',
  '180131',
  '180132',
  '180139',
  '180141',
  '180142',
  '180143',
  '180144',
  '180149',
  '180151',
  '180152',
  '180153',
  '180154',
  '180155',
  '180159',
  '180161',
  '180162',
  '180163',
  '180164',
  '180169',
  '180171',
  '180172',
  '180173',
  '180174',
  '180175',
  '180176',
  '180177',
  '180178',
  '180179',
  '180189',
  '180191',
  '180192',
  '180193',
  '180199',
  '180201',
  '180202',
  '180203',
  '180204',
  '180209',
  '180211',
  '180212',
  '180213',
  '180214',
  '180215',
  '180216',
  '180217',
  '180218',
  '180219',
  '180229',
  '180231',
  '180232',
  '180233',
  '180239',
  '180241',
  '180242',
  '180243',
  '180244',
  '180245',
  '180246',
  '180247',
  '180248',
  '180249',
  '180250',
  '180251',
  '180252',
  '180253',
  '180259',
  '180261',
  '180262',
  '180263',
  '180269',
  '180271',
  '180272',
  '180273',
  '180274',
  '180279',
  '180281',
  '180282',
  '180289',
  '180291',
  '180292',
  '180299',
  '180301',
  '180302',
  '180303',
  '180304',
  '180305',
  '180306',
  '180307',
  '180308',
  '180309',
  '180310',
  '180311',
  '180312',
  '180313',
  '180314',
  '180315',
  '180316',
  '180317',
  '180318',
  '180319',
  '180320',
  '180321',
  '180322',
  '180323',
  '180324',
  '180325',
  '180326',
  '180327',
  '180328',
  '180329',
  '180330',
  '180339',
  '180341',
  '180349',
  '180351',
  '180352',
  '180353',
  '180354',
  '180355',
  '180356',
  '180357',
  '180359',
  '180999',
  '190001',
  '190002',
  '190003',
  '190004',
  '190005',
  '190006',
  '190007',
  '190008',
  '190009',
  '190010',
  '190011',
  '190012',
  '190013',
  '190014',
  '190015',
  '190016',
  '190019',
  '190021',
  '190022',
  '190023',
  '190024',
  '190025',
  '190026',
  '190027',
  '190028',
  '190029',
  '190031',
  '190032',
  '190033',
  '190034',
  '190041',
  '190042',
  '190043',
  '190044',
  '190045',
  '190046',
  '190047',
  '190048',
  '190049',
  '190051',
  '190052',
  '190053',
  '190059',
  '190061',
  '190062',
  '190063',
  '190064',
  '190065',
  '190066',
  '190067',
  '190068',
  '190069',
  '190070',
  '190071',
  '190072',
  '190073',
  '190074',
  '190075',
  '190076',
  '190077',
  '190999',
  '200001',
  '200011',
  '200012',
  '200013',
  '200014',
  '200015',
  '200016',
  '200017',
  '200018',
  '200019',
  '200020',
  '200029',
  '200031',
  '200039',
  '200041',
  '200042',
  '200043',
  '200044',
  '200045',
  '200046',
  '200047',
  '200048',
  '200049',
  '200050',
  '200051',
  '200059',
  '200061',
  '200062',
  '200063',
  '200064',
  '200999',
  '210001',
  '210002',
  '210003',
  '210999',
  '220001',
  '220002',
  '220003',
  '220004',
  '220005',
  '220006',
  '220007',
  '220008',
  '220009',
  '220010',
  '220011',
  '220099',
  '230001',
  '230002',
  '230003',
  '230004',
  '230005',
  '230006',
  '230007',
  '230008',
  '230009',
  '230010',
  '230011',
  '230019',
  '230021',
  '230022',
  '230023',
  '230024',
  '230025',
  '230029',
  '230031',
  '230032',
  '230033',
  '230034',
  '230037',
  '230038',
  '230039',
  '230041',
  '230042',
  '230043',
  '230044',
  '230045',
  '230046',
  '230047',
  '230048',
  '230049',
  '230050',
  '230051',
  '230059',
  '230061',
  '230071',
  '230072',
  '230073',
  '230081',
  '230082',
  '230089',
  '230091',
  '230092',
  '230093',
  '230099',
  '230101',
  '230102',
  '230103',
  '230104',
  '230105',
  '230106',
  '230107',
  '230108',
  '230109',
  '230110',
  '230111',
  '230112',
  '230113',
  '230999',
  '240001',
  '240002',
  '240003',
  '240004',
  '240005',
  '240006',
  '240007',
  '240008',
  '240009',
  '240010',
  '240011',
  '240012',
  '240019',
  '240021',
  '240022',
  '240023',
  '240024',
  '240025',
  '240026',
  '240027',
  '240028',
  '240029',
  '240030',
  '240031',
  '240032',
  '240033',
  '240039',
  '240041',
  '240042',
  '240043',
  '240044',
  '240045',
  '240046',
  '240047',
  '240048',
  '240049',
  '240050',
  '240051',
  '240059',
  '240061',
  '240062',
  '240063',
  '240064',
  '240065',
  '240066',
  '240067',
  '240068',
  '240069',
  '240070',
  '240071',
  '240072',
  '240073',
  '240074',
  '240075',
  '240076',
  '240077',
  '240999',
  '250001',
  '250002',
  '250003',
  '250004',
  '250005',
  '250009',
  '250011',
  '250012',
  '250013',
  '250014',
  '250015',
  '250016',
  '250017',
  '250019',
  '250021',
  '250022',
  '250023',
  '250024',
  '250025',
  '250026',
  '250027',
  '250028',
  '250029',
  '250030',
  '250031',
  '250032',
  '250033',
  '250034',
  '250035',
  '250039',
  '250041',
  '250042',
  '250043',
  '250044',
  '250049',
  '250051',
  '250052',
  '250053',
  '250054',
  '250055',
  '250056',
  '250057',
  '250058',
  '250059',
  '250899',
  '250999',
  '260001',
  '260003',
  '260004',
  '260005',
  '260006',
  '260009',
  '260011',
  '260012',
  '260013',
  '260014',
  '260019',
  '260021',
  '260022',
  '260023',
  '260029',
  '260031',
  '260032',
  '260033',
  '260039',
  '260041',
  '260042',
  '260043',
  '260044',
  '260045',
  '260046',
  '260047',
  '260999',
  '270001',
  '270009',
  '270011',
  '270012',
  '270013',
  '270014',
  '270015',
  '270016',
  '270017',
  '270019',
  '270021',
  '270022',
  '270023',
  '270024',
  '270025',
  '270026',
  '270027',
  '270028',
  '270029',
  '270031',
  '270032',
  '270033',
  '270034',
  '270035',
  '270036',
  '270039',
  '270041',
  '270042',
  '270043',
  '270049',
  '270051',
  '270052',
  '270053',
  '270054',
  '270059',
  '280001',
  '280002',
  '280003',
  '280004',
  '280005',
  '280006',
  '280009',
  '280011',
  '280012',
  '280019',
  '280021',
  '280022',
  '280023',
  '280024',
  '280025',
  '280026',
  '280027',
  '280028',
  '280029',
  '280030',
  '280031',
  '280032',
  '280039',
  '280041',
  '280042',
  '280043',
  '280044',
  '280045',
  '280046',
  '280047',
  '280048',
  '280049',
  '280999',
  '290001',
  '290002',
  '290009',
  '290011',
  '290012',
  '290013',
  '290014',
  '290015',
  '290016',
  '290017',
  '290018',
  '290019',
  '290021',
  '290022',
  '290023',
  '290024',
  '290025',
  '290026',
  '290027',
  '290028',
  '290029',
  '300001',
  '300002',
  '300003',
  '300004',
  '310001',
  '310002',
  '310003',
  '310004',
  '310005',
  '310006',
  '310007',
  '310008',
  '310009',
  '310010',
  '310099',
  '320001',
  '320009',
  '320011',
  '320012',
  '320013',
  '330001',
  '330002',
  '330003',
  '330009',
  '330011',
  '330012',
  '330013',
  '330014',
  '330015',
  '330016',
  '330999',
  '340001',
  '350001',
  '350002',
  '350003',
  '350009',
  '350011',
  '350012',
  '350013',
  '350014',
  '350015',
  '350016',
  '350017',
  '360001',
  '360002',
  '370001',
  '370002',
  '370003',
  '370004',
  '370009',
  '370011',
  '370012',
  '370013',
  '370014',
  '380001',
  '380002',
  '380003',
  '380004',
  '380005',
  '380006',
  '380007',
  '380008',
  '380009',
  '380010',
  '380021',
  '380022',
  '380029',
  '380031',
  '380041',
  '380042',
  '390001',
  '390002',
  '390003',
  '390004',
  '390005',
  '410001',
  '420002',
  '420003',
  '420099',
  '430005',
  '430006',
  '430007',
  '430008',
  '430009',
  '430010',
  '430011',
  '430999',
  '450001',
  '450002',
  '450003',
  '450004',
  '450009',
  '450011',
  '450012',
  '450013',
  '450014',
  '450015',
  '450016',
  '450017',
  '450018',
  '450019',
  '450021',
  '450022',
  '450023',
  '450029',
  '450031',
  '450032',
  '450033',
  '450034',
  '450035',
  '450036',
  '450037',
  '450039',
  '450041',
  '450042',
  '450043',
  '450044',
  '450045',
  '450046',
  '450047',
  '450048',
  '450049',
  '450051',
  '450059',
  '450061',
  '450062',
  '450071',
  '450079',
  '450081',
  '450082',
  '450091',
  '450092',
  '450099',
  '450101',
  '450102',
  '450103',
  '450104',
  '450999',
  '470001',
  '470009',
  '470011',
  '470012',
  '470013',
  '470019',
  '470021',
  '470022',
  '470023',
  '470029',
  '470031',
  '470032',
  '470033',
  '470034',
  '470035',
  '470039',
  '470041',
  '470042',
  '470043',
  '470044',
  '470045',
  '470046',
  '470047',
  '470051',
  '470059',
  '470061',
  '470062',
  '470063',
  '470064',
  '470065',
  '470066',
  '470067',
  '470069',
  '470071',
  '470072',
  '470073',
  '470074',
  '470075',
  '490001',
  '500001',
  '510001',
  '520001',
  '520002',
  '520003',
  '520004',
  '520005',
  '520006',
  '520007',
  '520008',
  '520009',
  '520999',
  '530001',
  '530002',
  '550001',
  '560001',
  '610001',
  '710001',
  '760001',
  '760002',
  '770001',
  '770002',
  '770003',
  '770009',
  '850001',
  '850002',
  '850003',
  '850004',
  '860001',
  '860002',
  '860003',
  '860004',
  '860005',
  '860006',
  '860007',
  '860008',
  '860009',
  '860010',
  '860011',
  '860012',
  '870001',
  '870002',
  '910001',
  '930001',
  '950001',
  '950002',
  '950003',
  '950004',
  '950005',
  '950006',
  '950999',
  '960001',
  '960002',
  '960003',
  'G00098',
  'G00099',
  'G11199',
  'G20900',
  'G20901',
  'G20902',
];
